var render = function render(){var _vm=this,_c=_vm._self._c;return _c('WheelSlider',{attrs:{"list":[
    { perspective: 'center', items: _vm.feet, ref: 'feet', selectedIndex: _vm.feetIndex },
    { perspective: 'center', items: _vm.inches, ref: 'inches', selectedIndex: _vm.inchesIndex },
  ]},on:{"on-change":_vm.handleChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }